import { Injectable } from '@angular/core';
import { ISourceSystemType } from '../../../foundation/models/enums/source-system-type.enum';
import { TabObject } from '../../components/tabs/tabs.model';
import { RouteBuilderService } from './route-builder.service';

@Injectable()
/**
 * Builds transaction routes for finance
 */
export class HelpDeskRouteBuilderService extends RouteBuilderService {

    constructor() {
        super();
    }

    public get sourceSystemType(): ISourceSystemType {
        return this.sourceSystemTypes.HelpDesk;
    }

    /**
     * Gets the route list for the transaction type provided.
     * @returns: Array of routes for transaction.
     */
    getRouteList(businessTransactionTypeId: number): any[] {
        return this.getNmvtisRoutes();
    }

    getNmvtisRoutes(): TabObject[] {
        return ;
    }
}
